import React, { useState } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput,
    Accordion,
    Checkbox,
    Modal
} from '@mantine/core';
import { Calendar } from '@mantine/dates';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import { SchedulerDayCard } from '../components/SchedulerDayCard';
import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    }
}));


//needed:doc only a message property is needed
/*
 * FLOW
 * properties needed:
 *  - min & max Date
 *  -  days to be disabled bc auctioneer || staff assigned or bc all slots are filled
 *  weekends and stuff like that
 * */
//export function SchedulerCard(){
export const SchedulerCard = () => {
    const { classes } = useStyles();
    const [activeDate, setActiveDate] = useState(new Date());
    const [opened, setOpened] = useState(false);

    //needed: data format for scheduling(use surg focus as base reference)
    
    function calClicked(e){
        setActiveDate(e);
        console.log(`cal clicked active:\n\n ${activeDate}`);
        console.log(`cal clicked event:\n\n ${e}`);
        setOpened(true);
    }

    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Calendar
                        value={activeDate}
                        initialMonth={new Date()}
                        onChange={calClicked}
                        firstDayOfWeek="sunday"
                        focusable={true}
                        fullWidth={true}
                        preventFocus={true}
                        allowLevelChange={false}
                    />
                </Card.Section>
                <br/>
            </Card>
            <br/>
            <Button
                color="green"
                leftIcon={<IconCheck size={35} stroke={2.0}/>}
                fullWidth
                onClick={calClicked}
            ></Button>
            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Available Time Slots"
            >
                <SchedulerDayCard message={activeDate} />
            </Modal>
        </>
    )
}
//export default SchedulerCard
